import moment from 'moment'
import React,{useState,useEffect,useRef} from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { assetUrl } from '../../helpers'
import { FR,graphData } from '../../sdk'
import { Loader } from '../Default'
import { DataTable } from '../Default/DataTables/DataTable'
import { toasterFunction } from '../Default/ToasterComponent'
export const MainContent=(props)=> {
  const [state,setState]=useState({loader:true,date:moment().format("yyyy-MM-DD"),actualData:[],data:[],
  tbHeader:[{title:"ID",name:"ID"},{title:"Name",name:"name"},{title:"Date",name:"Date"},{title:"CheckIn",name:"CheckIn"},{title:"CheckOut",name:"CheckOut"},{title:"cameraId",name:"cameraId"},{title:"Image",name:"image"}],
  updated:false,tableLoader:false,
  buttonLoader:false,
  buttonDisabled:false,
  departments:[],
  subDepartments:[],
  count:1,
  imageViewer:{
  add:{
    frontImage:"",
    randomImage:"",
    leftImage:"",
    rightImage:"",
  },
  edit:{
    frontImage:"",
    randomImage:"",
    leftImage:"",
    rightImage:"",
  },

  },
  formAttr:{
    firstName:"",
    lastName:"",
    employeeId:"",
    employeeType:"",
    departmentId:"",
    subDepartmentId:"",
    subDepartmentName:"",
    frontImage:{},
    randomImage:{},
    leftImage:{},
    rightImage:{},
  },
  updateFormAttr:{
    firstName:"",
    lastName:"",
    employeeID:"",
    departmentId:"",
    subDepartmentId:"",
    subDepartmentName:"",
    frontImage:{},
    randomImage:{},
    leftImage:{},
    rightImage:{},
    id:0,
    index:0,
  }
  });
  const navigate=useNavigate();
  const params=useParams();
  const ref=useRef();
  const ref2=useRef();
  const onHandler=(event)=>{
    let key=event.target.name;
    let value=event.target.value;
    let oldState={...state}
    if(key==="frontImage" || key==="randomImage" || key==="leftImage" || key==="rightImage"){
      oldState.imageViewer.add[`${key}`]=URL.createObjectURL(event.target.files[0]);
      oldState.formAttr[key]=event.target.files[0];
    }
    else if(key==="departmentId"){
       let department=oldState.departments.find(val=>val.id===value);
       oldState.subDepartments=department ?department.subDept:[];
       oldState.formAttr[key]=value;    
    }
    else{
      if(key==="subDepartmentId"){
       oldState.formAttr["subDepartmentName"]=state.subDepartments.find(val=>val.id===value).name;
      }
      oldState.formAttr[key]=value;
    }
     
    setState((pre)=>{
      return {...pre,...oldState}
    })
    
  }
  const onUpdateHandler=(event)=>{
    let key=event.target.name;
    let value=event.target.value;
    let oldState={...state}
    if(key==="frontImage" || key==="randomImage" || key==="leftImage" || key==="rightImage"){
      oldState.imageViewer.edit[`${key}`]=URL.createObjectURL(event.target.files[0]);
      oldState.updateFormAttr[key]=event.target.files[0];
    }
    else if(key==="departmentId"){
       let department=oldState.departments.find(val=>val.id===value);
       oldState.subDepartments=department ?department.subDept:[];
       oldState.updateFormAttr[key]=value;    
    }
    else{
      if(key==="subDepartmentId"){
       oldState.updateFormAttr["subDepartmentName"]=state.subDepartments.find(val=>val.id===value).name;
      }
      oldState.updateFormAttr[key]=value;
    }
    setState((pre)=>{
      return {...pre,...oldState}
    })
    
  }
  const apiData=async()=>{

    try{
      let arr=[];
      
   let users=await new FR().employeeAttendanceDetails({employeeId:params.employeeId,date:params.date});
   let areaName=""
  
    let count=1;
    let duplicate = '';
   
     if(users.length){
     for(let val of users){
     
         arr.push([val.employeeId,val.employeeName,val.date,val.checkIn,val.checkOut,val.cameraId,`<a href=${assetUrl}${val.imageName} target='_blank'><img src=${assetUrl}${val.imageName} style="width:100%"; /></a>`])
         count++;
        
      }
    }
    setState((pre)=>{
      return {...pre,data:arr,loader:false,tableLoader:false,actualData:users,roles:[].data,count}
   })
    
   }catch(e){
    console.log(e)
    alert("error occur")
    }

}
const onDelete=async(id,index)=>{
try{
  if(window.confirm("are you want to delete this")){
    await new FR().delete(id.toString());
    toasterFunction.success("user has been deleted")
    //window.location.reload();
  }
 
}catch(e){

}
}
const onUpdate=(id,index)=>{
let data=state.actualData.find(val=> Number(val.id)===Number(id));
 if(data){
  let oldState={...state};
  oldState.updateFormAttr={...oldState.updateFormAttr,employeeID:data.employeeID,firstName:data.name.split(" ")[0],lastName:data.name.split(" ")[1],id,index};
  // let department=oldState.departments.find(val=>val.id===data.department);
  // oldState.subDepartments=department ?department.subDept:[];
  window.$("#showEditForm").modal("show")
  setState((pre)=>{
    return {...pre,...oldState}
  })
 }
 else{
  alert("data not found")
 }
  
}
const modalHandler=(id=false)=>{
window.$("#showForm").modal("show")
}
const onSubmitAdd=async (event)=>{
  event.preventDefault();
  if(Object.keys(state.formAttr.frontImage).length){
    toasterFunction.error("front image require");
    return false;
  }
  if(Object.keys(state.formAttr.randomImage).length){
    toasterFunction.error("random image require");
    return false;
  }
  if(Object.keys(state.formAttr.leftImage).length){
    toasterFunction.error("left image require");
    return false;
  }
  if(Object.keys(state.formAttr.rightImage).length){
    toasterFunction.error("right image require");
    return false;
  }
   ref.current.disabled=true;
  ref.current.firstElementChild.style.display="inline-block"
 try{
let result=await new FR().add(state.formAttr);

let oldState={...state};
toasterFunction.success("user has been added");
window.location.reload(); 
// oldData.push([result.employeeId,`${result.firstName} ${result.lastName}`,`<img src=${window.env.REACT_APP_SERVER_ASSET_URL}${result.frontImageUrl} style="width:100%;height:140px />`]);
// oldState.data=oldData;
// oldState.actualData.push(result);
// oldState.count=oldState.count +1;
// ref.current.disabled=false;
// ref.current.firstElementChild.style.display="none"
// window.$(".modal").modal("hide");
setState((pre)=>{
  return {...pre,...oldState}
})

}catch(e){
 
if(e.response.status===300){
  toasterFunction.error("Employee already taken")
}
else{
  toasterFunction.error(Object.values(e.response.data)[0][0])
}
ref.current.disabled=false;
ref.current.firstElementChild.style.display="none"
}
}
const onSubmitUpdate=async (event)=>{
  event.preventDefault();
  ref2.current.disabled=true;
  ref2.current.firstElementChild.style.display="inline-block"
 
try{
let result=await new graphData().updateEmployee({...state.updateFormAttr});
let oldState={...state};
toasterFunction.success("role has been updated");
ref2.current.disabled=false;
ref2.current.firstElementChild.style.display="none"
oldState.data=oldState.data.map(val=>{
if(Number(state.updateFormAttr.index)===Number(val[0])){
 return [ val[0].employeeID,result.name,result.department,`<button type="button" class="btn btn-danger delete" data-index=${val[0]}  data-id=${result.id}><i class="fa fa-trash" aria-hidden="true"></i></button> <button type="button" class="btn btn-default update" data-index=${oldState.count} data-id=${result.id}><i class="fa fa-pencil" aria-hidden="true"></i></button>`]
}
else{
  return val
}
});
oldState.actualData=oldState.actualData.map(val=>{
if(Number(state.updateFormAttr.id) !== Number(val.id)){
  return val;
}
else{
  return result;
}
});
window.$(".modal").modal("hide");
setState((pre)=>{
  return {...pre,...oldState}
})

}catch(e){
  
  if(e.response.status===300){
  toasterFunction.error("name already taken")
}
else{
  toasterFunction.error(e.response.data.message)
}
ref2.current.disabled=false;
ref2.current.firstElementChild.style.display="none"
}
}

useEffect(()=>{
apiData();
},[])
if(!state.loader){
  return (
    <>
      <div className="card mb-3">
       {/* BEGIN card-body */}
       <div className="card-body">
   <div className="col-12 mb-4">
     <div className="row">
       <div className="col-9">
       <div className="fw-bold mb-3">
   <span className="flex-grow-1 text-white">All Details</span>
   </div> 
       </div>
       <div className="col-3" style={{textAlign:"end"}}>
       <button type="button" style={{width:"30%"}} class="btn btn-theme" onClick={()=>{
       navigate("/in-out")
       }}>Back</button>
       </div>
      
     </div>
  
   </div>
   {state.tableLoader && <><Loader/></>}
   
   <div className="col-12">
  <DataTable headers={state.tbHeader} data={state.data} image={true} updated={state.updated} parentFun={{onUpdate,onDelete}} reverse={true}/>
  
   </div>
   </div>
   <div className="card-arrow">
         <div className="card-arrow-top-left" />
         <div className="card-arrow-top-right" />
         <div className="card-arrow-bottom-left" />
         <div className="card-arrow-bottom-right" />
       </div>
   </div>
   
   {/* <div class="modal" id="showForm">
  <div class="modal-dialog modal-xl">
    <div class="modal-content">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">Add New {props.type}</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
      </div>
      <div class="modal-body">
        <div className="row">
          <div className="col-12">
           <form onSubmit={onSubmitAdd}>
          <div className="row">
          <div className="col-xl-6" >
          <div className="form-group mb-3">
          <label className="form-label text-white" >
              First Name
            </label>
            <input
              type="text"
              className="form-control"
              placeholder="Enter First Name"
              name='firstName'
              value={state.formAttr.firstName}
              onChange={onHandler}
              required
            />
          </div>
        </div>
        <div className="col-xl-6" >
          <div className="form-group mb-3">
          <label className="form-label text-white" >
              Last Name
            </label>
            <input
              type="text"
              className="form-control"
              placeholder="Enter Last Name"
              name='lastName'
              value={state.formAttr.lastName}
              onChange={onHandler}
              required
            />
          </div>
        </div>
        <div className="col-xl-6" >
          <div className="form-group mb-3">
          <label className="form-label text-white" >
              ID
            </label>
            <input
              type="text"
              className="form-control"
              placeholder="Enter Id"
              name='employeeId'
              value={state.formAttr.employeeId}
              onChange={onHandler}
              required
            />
          </div>
        </div>
        
            
                <div className="col-xl-6">
                  <div className="row">
                    <div className="col-12">
                    <div class="mb-3">
														<label class="form-label" for="frontfile">Front Image</label>
														<input type="file" class="form-control" id="frontfile" name="frontImage" onChange={onHandler} accept="image/*"/>
													</div>
                    </div>
                    <div className="col-12">
                    <div class="mb-3">
													<img src={state.imageViewer.add.frontImage} alt={state.imageViewer.add.frontImage} style={{width:"100%",height: "135px"}}/>
													</div>
                    </div>
                  </div>
      
        </div>
        <div className="col-xl-6">
                  <div className="row">
                    <div className="col-12">
                    <div class="mb-3">
														<label class="form-label" for="randomfile">Random Image</label>
														<input type="file" class="form-control" id="randomfile" name="randomImage" onChange={onHandler} accept="image/*"/>
													</div>
                    </div>
                    <div className="col-12">
                    <div class="mb-3">
													<img src={state.imageViewer.add.randomImage} alt={state.imageViewer.add.randomImage} style={{width:"100%",height: "135px"}}/>
													</div>
                    </div>
                  </div>
      
        </div>
        <div className="col-xl-6">
                  <div className="row">
                    <div className="col-12">
                    <div class="mb-3">
														<label class="form-label" for="leftfile">Left Image</label>
														<input type="file" class="form-control" id="leftfile" name="leftImage" onChange={onHandler} accept="image/*"/>
													</div>
                    </div>
                    <div className="col-12">
                    <div class="mb-3">
													<img src={state.imageViewer.add.leftImage} alt={state.imageViewer.add.leftImage} style={{width:"100%",height: "135px"}}/>
													</div>
                    </div>
                  </div>
      
        </div>
        <div className="col-xl-6">
                  <div className="row">
                    <div className="col-12">
                    <div class="mb-3">
														<label class="form-label" for="leftfile">Right Image</label>
														<input type="file" class="form-control" id="rightfile" name="rightImage" onChange={onHandler} accept="image/*"/>
													</div>
                    </div>
                    <div className="col-12">
                    <div class="mb-3">
													<img src={state.imageViewer.add.rightImage} alt={state.imageViewer.add.rightImage} style={{width:"100%",height: "135px"}}/>
													</div>
                    </div>
                  </div>
      
        </div>
       
          <div className="col-xl-12"style={{textAlign:"center"}}>
          <button type="submit" class="btn btn-outline-theme w-25" ref={ref} disabled={false}>Add <div className="spinner-border" role="status" style={{height:"15px",width: "1rem" ,display:"none"}}></div></button>
          </div>
     
      </div>
    </form>
  </div>

        </div>
       </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-default " data-bs-dismiss="modal">Close</button>
        
      </div>
    </div>
     
     
    </div>
  </div>
</div> */}
{/* <div class="modal" id="showEditForm">
<div class="modal-dialog modal-xl">
    <div class="modal-content">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">Edit User</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
      </div>
      <div class="modal-body">
        <div className="row">
          <div className="col-12">
           <form onSubmit={onSubmitUpdate}>
          <div className="row">
          <div className="col-xl-6" >
          <div className="form-group mb-3">
          <label className="form-label text-white" >
              First Name
            </label>
            <input
              type="text"
              className="form-control"
              placeholder="Enter First Name"
              name='firstName'
              value={state.updateFormAttr.firstName}
              onChange={onUpdateHandler}
              required
            />
          </div>
        </div>
        <div className="col-xl-6" >
          <div className="form-group mb-3">
          <label className="form-label text-white" >
              Last Name
            </label>
            <input
              type="text"
              className="form-control"
              placeholder="Enter Last Name"
              name='lastName'
              value={state.updateFormAttr.lastName}
              onChange={onUpdateHandler}
              required
            />
          </div>
        </div>
        <div className="col-xl-6" >
          <div className="form-group mb-3">
          <label className="form-label text-white" >
              Employee ID
            </label>
            <input
              type="text"
              className="form-control"
              placeholder="Enter Employee Id"
              name='employeeID'
              value={state.updateFormAttr.employeeID}
              onChange={onUpdateHandler}
              required
            />
          </div>
        </div>
        
        <div className="col-xl-6">
                                  <div class="form-group mb-3">
                                    <label class="form-label" for="exampleFormControlSelect1">Department</label>
                                    <select class="form-select" id="exampleFormControlSelect1" onChange={onUpdateHandler} name="departmentId" required>
                                      <option value="">Select Department</option>
                                      {state.departments.map((v,index)=>{
                                          return (<>
                                          <option key={index} value={v.id} selected={Number(v.id) ===Number(state.updateFormAttr.departmentId)}>{v.name}</option>
                                          
                                          </>)
                                     })}
                                    </select>
                                  </div>
                                
                </div>
                <div className="col-xl-6">
                                  <div class="form-group mb-3">
                                    <label class="form-label" for="exampleFormControlSelect1">Sub Department</label>
                                    <select class="form-select" id="exampleFormControlSelect1" onChange={onUpdateHandler} name="subDepartmentId" required>
                                      <option value="">Select SubDepartment</option>
                                      {state.subDepartments.map((v,index)=>{
                                          return (<>
                                          <option key={index} value={v.id} selected={Number(v.id) ===Number(state.updateFormAttr.subDepartmentId)}>{v.name}</option>
                                          
                                          </>)
                                     })}
                                    </select>
                                  </div>
                                
                </div>
          <div className="col-xl-12"style={{textAlign:"center"}}>
          <button type="submit" class="btn btn-outline-theme w-25" ref={ref2} disabled={false}>Edit <div className="spinner-border" role="status" style={{height:"15px",width: "1rem" ,display:"none"}}></div></button>
          </div>
     
      </div>
    </form>
  </div>

        </div>
       </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-default " data-bs-dismiss="modal">Close</button>
        
      </div>
    </div>
     
     
    </div>
  </div>
</div> */}


 </>
 
    
   )
}
else{
  return (<>
  <Loader/>
  </>)
}
  
}
